import { Upload, Cpu, ShieldCheck, Layers, Wrench } from 'lucide-react'
import LandingNav from './LandingNav'
import LandingFooter from './LandingFooter'

const features = [
  {
    icon: Upload,
    title: 'Drawing Upload & Analysis',
    description: 'Upload DXF or PDF engineering drawings. Our AI extracts geometry, dimensions, tolerances, and annotations — automatically identifying pockets, holes, profiles, and contours.',
  },
  {
    icon: Cpu,
    title: 'AI-Powered G-Code Generation',
    description: 'Describe the job in plain language and get verified G-code for your CNC mill. The AI selects tools, calculates feeds and speeds, and generates complete programs.',
  },
  {
    icon: ShieldCheck,
    title: 'Tool Path Validation',
    description: 'Every generated program is validated against your drawing. Geometry matching, tool reach checks, and collision detection ensure the code is safe to run.',
  },
  {
    icon: Layers,
    title: 'Multi-Operation Support',
    description: 'Complex parts with multiple setups? Add operations for facing, roughing, finishing, drilling, and contouring — each with its own work offsets and tool selections.',
  },
  {
    icon: Wrench,
    title: 'Machine Profile Management',
    description: 'Configure your machine\'s work envelope, spindle specs, and capabilities. The AI tailors every program to your specific equipment.',
  },
]

export default function FeaturesPage() {
  return (
    <div className="min-h-screen bg-[#030712] flex flex-col">
      <LandingNav />

      <div className="flex-1 pt-14">
        {/* Header */}
        <div className="max-w-4xl mx-auto px-6 pt-16 pb-12 text-center">
          <h1
            className="text-3xl md:text-5xl font-extrabold tracking-tight mb-4"
            style={{
              fontFamily: 'Barlow, sans-serif',
              fontWeight: 900,
              background: 'linear-gradient(135deg, #06b6d4, #3b82f6)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              filter: 'drop-shadow(0 0 16px rgba(6, 182, 212, 0.3))',
            }}
          >
            Features
          </h1>
          <p className="font-mono text-sm text-slate-400 max-w-lg mx-auto">
            Everything you need to go from engineering drawing to verified G-code,
            without expensive CAM software.
          </p>
        </div>

        {/* Feature cards */}
        <div className="max-w-4xl mx-auto px-6 pb-24 space-y-6">
          {features.map(({ icon: Icon, title, description }) => (
            <div
              key={title}
              className="glass rounded-xl p-8 flex items-start gap-6 hover:border-cyan-500/30 transition-all duration-150"
            >
              <div className="w-12 h-12 rounded-xl bg-cyan-500/10 flex items-center justify-center shrink-0">
                <Icon className="w-6 h-6 text-cyan-500/70" />
              </div>
              <div>
                <h2
                  className="text-xl mb-2 text-slate-200"
                  style={{ fontFamily: 'Barlow, sans-serif', fontWeight: 800 }}
                >
                  {title}
                </h2>
                <p className="font-mono text-sm text-slate-400 leading-relaxed">
                  {description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <LandingFooter />
    </div>
  )
}
